export function EditPencilIcon({ className }: { className?: string }) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role="img"
      aria-label="Edit"
    >
      <path
        d="M1.60991 8.61502C1.31732 8.90756 1.10403 9.27392 0.991912 9.6731L0.0238932 13.1672C-0.0390007 13.3941 0.0238931 13.6402 0.193433 13.807C0.362973 13.9738 0.606345 14.0394 0.83331 13.9765L4.32802 13.0059C4.72726 12.8938 5.09095 12.6833 5.38628 12.388L13.4258 4.34989C13.7922 3.98079 14 3.47772 14 2.95278C14 2.42784 13.7922 1.92478 13.4203 1.55568L12.4441 0.57962C12.0749 0.207788 11.5718 0 11.0467 0C10.5217 0 10.0185 0.207788 9.64939 0.57962L1.60991 8.61775V8.61502ZM11.0467 1.31235C11.2217 1.31235 11.3913 1.38343 11.5171 1.50647L12.4933 2.48252C12.6191 2.60829 12.6874 2.77507 12.6874 2.95278C12.6874 3.1305 12.6163 3.29727 12.4933 3.42304L11.0467 4.86936L9.12983 2.95278L10.5764 1.50647C10.7022 1.3807 10.869 1.31235 11.0467 1.31235ZM3.00451 9.07707L8.20283 3.87963L10.1197 5.7962L4.92141 10.9936L3.00451 9.07707ZM2.22244 10.1516L3.84675 11.7756L1.59897 12.399L2.22244 10.1516Z"
        fill="currentColor"
      />
    </svg>
  );
}
